import { render } from "./InfoBasicas.vue?vue&type=template&id=48678ef2&scoped=true"
import script from "./InfoBasicas.vue?vue&type=script&lang=js"
export * from "./InfoBasicas.vue?vue&type=script&lang=js"

import "./InfoBasicas.vue?vue&type=style&index=0&id=48678ef2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48678ef2"]])

export default __exports__